import { useAuth } from "../contexts/AuthContext";

export const useEmailVerification = () => {
  const { user } = useAuth();
  
  const isEmailVerified = user?.isEmailVerified || false;

  return {
    isEmailVerified,
    isRestricted: !isEmailVerified,
    email: user?.email,
  };
};